import { setInteractionError } from '@atlaskit/react-ufo/set-interaction-error';
import traceUFOPageLoad from '@atlaskit/react-ufo/trace-pageload';
import traceUFOPress from '@atlaskit/react-ufo/trace-press';
import traceUFOTransition from '@atlaskit/react-ufo/trace-transition';
import { Events } from '../../events';
import { isIgnoreableUfoEvent } from '../../utils/errors';
const createListener = _ref => {
  let {
    isBot
  } = _ref;
  return (event, getContext) => {
    if (isIgnoreableUfoEvent(event) || isBot) {
      return;
    }
    switch (event.type) {
      case Events.LABEL_TRACE_UFO_PAGE_LOAD:
        {
          const {
            isInitialRender
          } = getContext();
          const ufoName = event.routeName.toLowerCase();
          if (isInitialRender) {
            traceUFOPageLoad(ufoName, event.routeName);
          } else {
            traceUFOTransition(ufoName, event.routeName);
          }
          break;
        }
      case Events.LABEL_UFO_INTERACTION_ERROR:
        {
          const {
            page
          } = getContext();
          const interactionName = event.interactionName || page.toLowerCase();
          setInteractionError(interactionName, event.error);
          break;
        }
      case Events.LABEL_TRACE_UFO_PRESS:
        {
          const interactionName = event.interactionName;
          traceUFOPress(interactionName);
          break;
        }
    }
  };
};
export default createListener;